import { RouterProvider } from 'react-router-dom';
import { router } from './routing/router';
import { Box } from '@mui/material';
import { AuthProvider } from './context';

function App() {
  return (
    <Box>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </Box>
  );
}

export default App;
